<div class="d-flex justify-content-center">
	<div class="col-8">
		<p>Whoop's looks like something went wrong and we can't find what your looking for.</p>
<a href="" routerLink="/book">Try looking here...</a>
	</div>
</div>
